import React, { useEffect, useState } from "react";
import { hitApi } from "../utils/apiCall";
import { useParams } from "react-router-dom";
import { Tab, Tabs } from "react-bootstrap";
import accessDenied from "../pages/assets/accessDenied.png";
import "./detailsStyles.css";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "INR",
});
function convertDateFormat(dateString) {
  const [year, month, day] = dateString?.split("-");
  return `${day}-${month}-${year}`;
}

const mId = 11;
const sId = 5;

function ParticularStudentFeeReport() {
  const { id, seid } = useParams();
  const [fetchedBasicData, setFetchedBasicData] = useState({});
  const [key, setKey] = useState("allocated");
  const [feeHistory, setFeeHistory] = useState([]);
  const [fetchedAllocatedFeeData, setFetchedAllocatedFeeData] = useState([]);
  const [access, setAccess] = useState({});

  useEffect(() => {
    async function getAccessDetails() {
      const fd = new FormData();
      fd.append("subMenu", sId);
      fd.append("menuId", mId);
      const res = await hitApi("permission/permission", "getAccessDetails", fd);
      if (res.success) {
        setAccess(res.data[0]);
      } else {
        setAccess({});
      }
    }
    getAccessDetails();
  }, []);

  useEffect(() => {
    async function fetchBasicDetails(stdId, enrId) {
      const fd = new FormData();
      fd.append("studentId", stdId);
      fd.append("enrollId", enrId);
      const res = await hitApi(
        "admission/createAddmissionMain",
        "getStudentDetailsAllInfo",
        fd
      );
      if (res.success) {
        setFetchedBasicData(res.data[0]);
      } else {
        setFetchedBasicData(res.data[0]);
      }
    }
    fetchBasicDetails(id, seid);
  }, [id, seid]);

  useEffect(() => {
    async function getFeeHistory(studId, bid, sid) {
      const fd = new FormData();
      fd.append("studentId", studId);
      fd.append("branch", bid);
      fd.append("session", sid);
      const res = await hitApi(
        "studentAccounting/collect_fees",
        "getPaidPaymentDetailsFromStudentIdForApp",
        fd
      );
      if (res.success) {
        setFeeHistory(res.data);
      } else {
        setFeeHistory([]);
      }
    }
    id &&
      getFeeHistory(
        id,
        fetchedBasicData?.branch_id,
        fetchedBasicData?.session_id
      );

    async function fetchBasicDetails(stdId, bid, sid) {
      const fd = new FormData();
      fd.append("studentId", stdId);
      fd.append("branch", bid);
      fd.append("session", sid);
      const res = await hitApi(
        "studentAccounting/feeAllocation",
        "getAllocatedFeeDetailsForParticularStudent",
        fd
      );
      // console.log(res);

      if (res.success) {
        setFetchedAllocatedFeeData(res.data);
      } else {
        setFetchedAllocatedFeeData(res.data);
      }
    }
    id &&
      fetchedBasicData?.branch_id &&
      fetchedBasicData?.session_id &&
      fetchBasicDetails(
        id,
        fetchedBasicData?.branch_id,
        fetchedBasicData?.session_id
      );
  }, [id, fetchedBasicData?.branch_id, fetchedBasicData?.session_id]);

  return (
    <div
      className="d-flex flex-column justify-content-start align-items-center px-2"
      style={{ marginBottom: "5rem" }}
    >
      <div className="w-100 px-2 mt-2">
        {access?.is_view === "0" && (
          <div className="d-flex flex-column justify-content-center align-items-center">
            <img src={accessDenied} alt="" />
            <br />
            <h1>No access</h1>
          </div>
        )}
        {access?.is_view === "1" && (
          <div className="card px-0 mt-2 shadow-sm border-4">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="card-header p-0 px-1 m-0 bg-subtle"
            >
              {/* Allocated */}
              <Tab eventKey="allocated" title="Allocated">
                <div
                  className="card-body"
                  style={{
                    maxHeight: "calc(100vh - 20rem)",
                    overflowY: "auto",
                  }}
                >
                  <div className="w-100 py-2 rounded-2">
                    Total Allocated Amount
                    <span className="ms-2 fw-bold">
                      {formatter.format(
                        fetchedAllocatedFeeData?.reduce(
                          (prev, curr) =>
                            prev + parseFloat(curr.allocated_amount),
                          0
                        )
                      )}
                    </span>
                  </div>
                  {fetchedAllocatedFeeData?.map((ele) => {
                    return (
                      <div className="w-100 mycard py-3">
                        <small className="d-block">{ele.fee_type_name}</small>
                        <small className="d-flex justify-content-between">
                          <span className="fw-bold">
                            {formatter.format(ele.allocated_amount)}
                          </span>
                          <span>
                            {ele.due_date &&
                              convertDateFormat(`${ele.due_date}`)}
                          </span>
                        </small>
                      </div>
                    );
                  })}
                </div>
              </Tab>

              {/* Paid */}
              <Tab eventKey="paid" title="Paid">
                <div
                  className="card-body"
                  style={{
                    maxHeight: "calc(100vh - 20rem)",
                    overflowY: "auto",
                  }}
                >
                  <div className="w-100 py-2">
                    Total Paid Amount
                    <span className="ms-2 fw-bold">
                      {formatter.format(
                        feeHistory?.reduce(
                          (prev, curr) => prev + parseFloat(curr.paid_amount),
                          0
                        )
                      )}
                    </span>
                  </div>
                  {feeHistory?.map((ele) => {
                    return (
                      <div className="mycard w-100 py-3">
                        <span className="d-flex justify-content-between">
                          <small className="d-block">
                            {ele?.fee_type_name}
                          </small>
                          <small className="d-block">
                            {convertDateFormat(ele?.date)}
                          </small>
                        </span>
                        <small className="d-flex justify-content-between">
                          <span className="fw-bold">
                            {formatter.format(ele?.paid_amount)}
                          </span>
                          &nbsp;
                          <span>
                            {ele.payment_via}
                            {ele.utrNumber && `: ${ele?.utrNumber}`}
                          </span>
                        </small>
                        <small className="d-flex justify-content-between">
                          <span>{ele?.collect_by_name}</span>
                          &nbsp;
                          <span>{ele?.receiptNumber}</span>
                        </small>
                      </div>
                    );
                  })}
                </div>
              </Tab>

              {/* Due */}
              <Tab eventKey="due" title="Due">
                <div
                  className="card-body"
                  style={{
                    maxHeight: "calc(100vh - 20rem)",
                    overflowY: "auto",
                  }}
                >
                  <div className="w-100 py-2">
                    Total Due Amount
                    <span className="ms-2 fw-bold">
                      {formatter.format(
                        fetchedAllocatedFeeData?.reduce(
                          (prev, curr) =>
                            prev + parseFloat(curr.allocated_amount),
                          0
                        ) -
                          fetchedAllocatedFeeData?.reduce(
                            (prev, curr) => prev + parseFloat(curr.total_paid),
                            0
                          )
                      )}
                    </span>
                  </div>
                </div>
              </Tab>

              {/* Discount */}
              <Tab eventKey="discount" title="Discount">
                <div
                  className="card-body"
                  style={{
                    maxHeight: "calc(100vh - 20rem)",
                    overflowY: "auto",
                  }}
                >
                  <div className="w-100 py-2">
                    Total Discount Amount
                    <span className="ms-2 fw-bold">
                      {formatter.format(
                        fetchedAllocatedFeeData?.reduce(
                          (prev, curr) =>
                            prev + parseFloat(curr.discountAtPayment),
                          0
                        )
                      )}
                    </span>
                  </div>
                  {/* {fetchedAllocatedFeeData?.map((ele) => {
                  return (
                    ele.discount !== "0.00" && (
                      <div className="mycard w-100 py-3">
                        <small className="d-block">{ele.fee_type_name}</small>
                        <small className="d-flex justify-content-between">
                          <span>{formatter.format(ele.discount)}</span>
                          &nbsp;
                          <span>
                            {ele.payment_via}
                            {ele.utrNumber && `: ${ele.utrNumber}`}
                          </span>
                        </small>
                        <small className="d-flex justify-content-between">
                          <span>{ele.collect_by_name}</span>
                          &nbsp;
                          <span>{ele.receiptNumber}</span>
                        </small>
                      </div>
                    )
                  );
                })} */}
                </div>
              </Tab>
            </Tabs>
          </div>
        )}
      </div>
    </div>
  );
}

export default ParticularStudentFeeReport;
